import { render, staticRenderFns } from "./inspePlanAdd.vue?vue&type=template&id=85203f7a&scoped=true"
import script from "./inspePlanAdd.vue?vue&type=script&lang=js"
export * from "./inspePlanAdd.vue?vue&type=script&lang=js"
import style0 from "./inspePlanAdd.vue?vue&type=style&index=0&id=85203f7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85203f7a",
  null
  
)

export default component.exports